import { Filter } from '@anytag/shared-molecules';
import { useYoutubeInfluencersContext } from '../YoutubeInfluencersContext';
import { BasicFilter } from './BasicFilter';

export const YoutubeInfluencersFilter = () => {
  const { filter, setFilter, isEngagementPage, isPackagePage } = useYoutubeInfluencersContext();

  return (
    <Filter.Provider onSubmit={setFilter} values={filter} className="rounded-none">
      <BasicFilter isEngagementPage={isEngagementPage} isPackagePage={isPackagePage} />
    </Filter.Provider>
  );
};
